var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "pt-2" },
    [
      _vm.loading
        ? _c(
            "b-row",
            [
              _c("font-awesome-icon", {
                attrs: { icon: "spinner", size: "lg", spin: "" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loading && !_vm.saving
        ? _c("b-row", { staticClass: "text-left" }, [
            _c(
              "ol",
              _vm._l(_vm.recommendations, function(recommendation) {
                return _c(
                  "li",
                  { key: recommendation.id },
                  [
                    _c("font-awesome-icon", {
                      attrs: {
                        icon: "edit",
                        id: "edit-me-" + recommendation.id,
                        size: "sm"
                      },
                      on: {
                        click: function($event) {
                          _vm.editingId = recommendation.id
                          _vm.newRecommendation = recommendation.recommendation
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(recommendation.recommendation)
                      }
                    })
                  ],
                  1
                )
              })
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "pt-3 text-left" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "recommendationgroup",
                    breakpoint: "md",
                    label: "Add Recommendation",
                    "label-for": "recommendation",
                    validated: ""
                  }
                },
                [
                  _c("wysiwyg", {
                    attrs: { id: "recommendation" },
                    model: {
                      value: _vm.newRecommendation,
                      callback: function($$v) {
                        _vm.newRecommendation = $$v
                      },
                      expression: "newRecommendation"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "pt-3" },
        [
          _c(
            "b-col",
            [
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "success",
                    disabled: !_vm.newRecommendation
                  },
                  on: {
                    click: function($event) {
                      _vm.save()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.editingId ? "Update" : "Add"))]
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.editingId
            ? _c(
                "b-col",
                [
                  _c("vue-confirmation-button", {
                    ref: "deleteButton",
                    attrs: {
                      css: "btn btn-danger",
                      messages: [
                        "Delete",
                        "Are you sure?",
                        "Deleted, reloading....."
                      ]
                    },
                    on: {
                      "confirmation-success": function($event) {
                        _vm.deleteItem()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _vm.newRecommendation || _vm.editingId
                ? _c(
                    "b-button",
                    {
                      attrs: { variant: "default" },
                      on: {
                        click: function($event) {
                          _vm.newRecommendation = ""
                          _vm.editingId = null
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-574facd0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-574facd0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecommendationsList.vue
// module id = null
// module chunks = 